exports.components = {
  "component---src-pages-markdown-remark-fields-slug-tsx": () => import("./../../../src/pages/{MarkdownRemark.fields__slug}.tsx" /* webpackChunkName: "component---src-pages-markdown-remark-fields-slug-tsx" */),
  "component---src-pages-news-index-tsx": () => import("./../../../src/pages/news/index.tsx" /* webpackChunkName: "component---src-pages-news-index-tsx" */),
  "component---src-pages-opening-hours-tsx": () => import("./../../../src/pages/opening-hours.tsx" /* webpackChunkName: "component---src-pages-opening-hours-tsx" */)
}

